import { CatActionTypes } from './cat.types';

export const setExistingCategories = categories => ({
  type: CatActionTypes.SET_EXISTING_CATEGORIES,
  payload: categories
});


